import General from 'src/utils/GeneralUtils';

interface NrMatchesSnippetProps {
  nrMatches: number;
  uniqueDistricts?: number;
  /** Number of accounts (for grouped view) */
  accountCount?: number;
  /** Custom label for items (e.g., "contact", "district"). Defaults to "match" */
  itemLabel?: string;
}

export default function NrMatchesSnippet({ nrMatches, uniqueDistricts, accountCount, itemLabel }: NrMatchesSnippetProps) {
  const matchesText = nrMatches === 10000 ? `10,000+` : General.addCommasToNumber(nrMatches);

  // Use custom label if provided, otherwise default to "match/matches"
  const getPlural = (label: string) => {
    if (label === 'person') return 'people';
    return `${label}s`;
  };
  const matchWord = itemLabel
    ? (nrMatches === 1 ? itemLabel : getPlural(itemLabel))
    : (nrMatches === 1 ? 'match' : 'matches');

  // For grouped view, show "in X accounts"
  const groupText = accountCount && accountCount > 0
    ? ` in ${General.addCommasToNumber(accountCount)} ${accountCount === 1 ? 'account' : 'accounts'}`
    : '';

  // For non-grouped contact view, show "across X districts"
  const districtsText = !accountCount && uniqueDistricts && uniqueDistricts > 0
    ? ` across ${General.addCommasToNumber(uniqueDistricts)} ${uniqueDistricts === 1 ? 'district' : 'districts'}`
    : '';

  return <div className='desc-2'>
    Found {matchesText} {matchWord}{groupText}{districtsText}
  </div>
}
